export default "__VITE_ASSET__CByD34Ma__"